import { clsx } from "clsx";
import React, { FunctionComponent, useCallback, useState } from "react";
import { DropzoneOptions, useDropzone } from "react-dropzone";

import { fileToBase64 } from "../../util/fileToBase64";

export const FileUploader: FunctionComponent<{
  defaultValue?: string;
  dropzoneOptions?: Omit<DropzoneOptions, "onDrop">;
  label: string;
  name: string;
}> = ({ defaultValue, dropzoneOptions, label, name }) => {
  const [base64, setBase64] = useState<null | string>(null);

  const previewSrc = base64 || defaultValue;

  const value = base64?.replace(/data:.*base64,\s*/, "") || "";

  const onDrop = useCallback((acceptedFiles: File[]) => {
    acceptedFiles.forEach((file: File) => {
      const reader = new FileReader();
      reader.onabort = (): void => {
        setBase64(null);
      };
      reader.onerror = (): void => {
        setBase64(null);
      };
      reader.onload = async (): Promise<void> => {
        const base64 = await fileToBase64(file);
        setBase64(base64);
      };
      reader.readAsArrayBuffer(file);
    });
  }, []);

  const { getInputProps, getRootProps } = useDropzone({
    ...dropzoneOptions,
    onDrop,
  });

  return (
    <div className="flex gap-2 items-center">
      {previewSrc && (
        <img
          alt="image"
          className="min-w-[4rem] max-w-[6rem] bg-paper-2"
          src={previewSrc}
        />
      )}
      <div
        {...getRootProps()}
        className={clsx(
          "rounded-input transition border border-edge bg-input",
          "px-4 py-2 md:py-4",
          "text-center cursor-pointer user-select-none",
          "flex-1"
        )}
      >
        <input {...getInputProps()} />
        <input name={name} type="hidden" value={value} />
        {label}
      </div>
    </div>
  );
};
